const constants = require('../../utils/domain/constants');
const stringUtil = require('../../utils/string/stringUtil');
const dateUtil = require('../../utils/dateUtil/dateUtil');
const stateManager = require('../../utils/state/stateManager');

module.exports.getSnoozes = function()
{
    return stateManager.getStore().getState().snoozes;
}

module.exports.isItemSnoozedForSale = function (item, itemType, menu, sale)
{
    let snoozes = stateManager.getStore().getState().snoozes;
    snoozes = snoozes.filter(snooze => isSnoozeApplicable(menu, sale, snooze));

    if (isItemSnoozedForMenuItem(item, itemType, snoozes))
        return true 

    return isItemSnoozedForTag(item, snoozes)
}

function isSnoozeApplicable(menu, sale, snooze)
{
    if (snooze.expiry != "-1" && dateUtil.isAfter(dateUtil.getNow(), snooze.expiry))
        return false;

    if (snooze.dispatchTypes != null && snooze.dispatchTypes.length > 0 && !snooze.dispatchTypes.includes(sale.dispatchType))
        return false;

    if (snooze.venueCodes != null && snooze.venueCodes.length > 0 && !snooze.venueCodes.includes(sale.venueCode))
        return false;

    if (snooze.menus != null && snooze.menus.length > 0 && !snooze.menus.includes(menu.id))
        return false;

    return true;
}

function isItemSnoozedForMenuItem(item, itemType, snoozes)
{
    const snooze = snoozes.find(x => stringUtil.areStringSame(x.type, constants.SnoozeTypes.menuItem) 
                                            && stringUtil.areStringSame(x.secondaryId, itemType)
                                            && stringUtil.areStringSame(x.primaryId, item.id))
        
    return snooze != null;
}


function isItemSnoozedForTag(item, snoozes)
{
    if (stringUtil.isStringNullOrEmpty(item.paramsJson))
        return false;

    let configuration = JSON.parse(item.paramsJson);
    if (configuration == null || configuration.snoozeConfiguration == null ||
        configuration.snoozeConfiguration.snoozeTags == null || configuration.snoozeConfiguration.snoozeTags.length <= 0)
        return false;

    let menuSnoozeTags = configuration.snoozeConfiguration.snoozeTags;
    menuSnoozeTags = menuSnoozeTags.split(",");
    if (menuSnoozeTags == null || menuSnoozeTags.length <= 0)
        return false;
    
    let isSnoozed = false;
    menuSnoozeTags.forEach(snoozeTag =>
        {
            isSnoozed = isSnoozed || isTagSnoozedForSale(snoozeTag, snoozes);
        })

    return isSnoozed;
}

function isTagSnoozedForSale(tag, snoozes)
{
    const snooze = snoozes.find(a => stringUtil.areStringSame(a.type, constants.SnoozeTypes.tag) && stringUtil.areStringSame(a.primaryId, tag));
    
    return snooze != null;
}